export default __webpack_public_path__ + "static/media/IMG9732.c32c3783.jpg";